import axios, { AxiosError } from 'axios';
import { GetAllPaymentsResponse } from './types';

const paymentsUrl = process.env.REACT_APP_PAYMENTS_API_URL || '';

class PaymentsClient {
  getAllPaymentsForUser(driverId: number) {
    return new Promise<GetAllPaymentsResponse>((resolve, reject) => {
      axios
        .get<GetAllPaymentsResponse>(`${paymentsUrl}/driver/${driverId}/payments/all`)
        .then((response) => resolve(response.data))
        .catch((axiosError) => reject(axiosError.message));
    });
  }

  getErrorMessage(error: AxiosError) {
    const status = (error && error.response && error.response.status) || null;

    let message = 'Er is een onbekende fout opgetreden';

    if (status === null) {
      message = 'Logistics is tijdelijk onbereikbaar. Probeer het later opnieuw.';
    } else if (status === 401 || status === 403) {
      message =
        'U heeft geen rechten om deze actie uit te voeren. Neem contact op met de klantenservice.';
    } else if (status === 400 && error.response && error.response.data.detail) {
      message = error.response.data.detail;
    }

    return message;
  }
}

const paymentsClient = new PaymentsClient();

export { paymentsClient };
